<template>
  <component
    :is="component"
    v-on="$listeners"
    class="app-dialog-content"
    :class="[display, variantClass]"
  >
    <slot />
  </component>
</template>

<script> 
export default {
  name: 'DialogContent',

  inject: ['variant'],

  computed: {
    variantClass() {
      return this.variant
    }
  },

  props: {
    component: {
      type: String,
      default: 'div', 
    },

    display: {
      default: 'minimal',
      type: String,
    }
  },
};
</script>

<style scoped>
.app-dialog-content {
  overflow: auto;
}

.app-dialog-content.none {
  padding: 0px;
}

.app-dialog-content.minimal {
  padding: 25px;
}

.app-dialog-content.narrow {
  padding: 50px 25px;
  max-width: 400px;
  margin: auto;
}

.app-dialog-content.medium {
  padding: 50px 25px;
  max-width: 800px;
  margin: auto;
}

.app-dialog-content.center {
  max-height: calc(100vh - 200px);
}

.app-dialog-content.right,
.app-dialog-content.left {
  height: calc(100vh - 75px);
  max-width: 600px;
}

</style>
